/**
 * To reload the current page.
 */
function locationReload(): void {
  globalThis.location.reload();
}

export { locationReload };
